
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40.003"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.706.009a.806.806 0 00-.475.225L.355 8.131a.763.763 0 00-.125.1.378.378 0 00-.05.05c-.019.025-.034.05-.05.075a.673.673 0 00-.075.15.784.784 0 00-.049.225.819.819 0 000 .178v30.3a.8.8 0 00.8.8h2.4a.8.8 0 00.8-.8v-13.6h9.6v1.6h-8.8v1.6h8.8v1.6h-8.8v1.6h8.8v1.6h-8.8v1.6h8.8v1.6h-8.8v1.6h8.8v.8a.8.8 0 00.8.8h2.4a.8.8 0 00.8-.8v-14.28a.835.835 0 000-.125V8.931a.835.835 0 000-.125v-.125a.935.935 0 00-.025-.1.869.869 0 00-.05-.125l-.025-.025a.963.963 0 00-.1-.15v-.025l-.025-.025h-.025a.378.378 0 00-.05-.05L9.379.232a.807.807 0 00-.673-.223zm.1 1.95l6.047 6.05H2.755zm-7.2 7.65h14.4v14.4h-14.4zm7.2 1.6a5.6 5.6 0 105.6 5.6 5.622 5.622 0 00-5.6-5.6zm0 1.6a4 4 0 11-4 4 4.007 4.007 0 014-4zm9.6 3.2v1.6a7.076 7.076 0 015.974 2.525 18.786 18.786 0 012.85 5.9 22.448 22.448 0 002.925 6.374 7.919 7.919 0 006.649 3.125 1.777 1.777 0 011.6 1.825v.975c-4.412-.106-7.458-.9-9.449-2.075a9.965 9.965 0 01-4.075-4.6c-.816-1.715-1.259-3.487-2.075-4.974a4.814 4.814 0 00-4.399-2.675v1.6a2.871 2.871 0 012.975 1.825c.662 1.212 1.156 3.04 2.05 4.924a11.712 11.712 0 004.7 5.3c2.447 1.444 5.94 2.35 11.074 2.35a.8.8 0 00.8-.8v-1.85a3.333 3.333 0 00-3.2-3.425 6.083 6.083 0 01-5.374-2.5 21.808 21.808 0 01-2.68-5.924 19.927 19.927 0 00-3.15-6.424 8.876 8.876 0 00-7.195-3.076zm-16.8 9.6h.8v12.8h-.8zm13.6 0h.8v12.8h-.8z","fill":"#38470b"}})])
          )
        }
      }
    